/** Resolve the optional knowledge-base URL for the current deployment. */
export function resolveDocsUrl(configuredUrl: string, origin: string): string | undefined {
	const value = configuredUrl.trim();
	if (!value) return undefined;
	return value === "auto" ? `${origin.replace(/\/$/, "")}/docs/` : value;
}
